<!--
 * @Author: Admni
 * @Description: 
 * @Date: 2020-12-25 16:45:25
 * @LastEditTime: 2021-03-03 11:12:35
-->
<template>
  <div class="user-item">
    <div class="avatar">
      <img src="../../assets/img/kehu_list.png" alt="" />
    </div>
    <div class="center">
      <div class="name">{{ name ? name : "" }}</div>
      <div class="news">{{ msg ? msg : "" }}</div>
    </div>
    <div class="hasNews" v-if="hasNews">{{ hasNews ? hasNews : "" }}</div>
    <div class="close">
      <i class="el-icon-close" @click.stop="removeCurChat()"></i>
    </div>
  </div>
</template>

<script>
import { removeChat } from "../../api/chat";
export default {
  name: "user-item",
  props: ["name", "msg", "hasNews", "i", "curPkg"],
  data() {
    return {};
  },
  computed: {
    Msg() {
      if (this.msg.indexOf("fl@:") !== -1) {
        return "文件";
      } else if (this.msg.indexOf("il@:") !== -1) {
        return "图片";
      } else {
        return this.msg;
      }
    },
  },
  methods: {
    removeCurChat() {
      removeChat({ pkg: this.curPkg, u_id: this.i })
        .then((res) => {
          if (res.result !== -1) {
            this.$message({
              message: '移除成功',
              type: "success",
            });
            window.location.reload()
          } else {
            this.$message({
              message: '移除失败',
              type: "warning",
            });
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.user-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 20px;
  position: relative;
  .avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #779fb3;
    img {
      width: 60%;
      height: 60%;
    }
  }
  .center {
    margin-left: 20px;
    flex: 1;
    overflow: hidden;
    .name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 15px;
      color: #333333;
      margin-bottom: 10px;
    }
    .news {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
      color: #8d8d8d;
    }
  }
  .hasNews {
    // margin-right: 10px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    line-height: 16px;
    background: #d92f2f;
    text-align: center;
    color: #ffffff;
    font-size: 12px;
  }
  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    opacity: 0;
    transition: all 0.3s linear;
    font-size: 20px;
    color: #333333;
  }
}
.user-item:hover .close {
  opacity: 1;
}
</style>